import { FlowStepEditor } from "../FlowStepEditor";
import React from "react";
import { RunFlow } from "../../../rule-engine-core/Flow/Steps/General/RunFlow";

export class RunFlowEditor extends FlowStepEditor<RunFlow> {
    renderEditUI(): JSX.Element | null {
        return <div>run flow</div>;
    }
}
